
import { Component, Vue } from "vue-property-decorator";
import { editGanyu, GanyuDetail } from "@/request/content";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import Pagination from "@/components/paginaiton.vue";
declare module "vue/types/vue" {
  interface Vue {
    [key: string]: any;
  }
}
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
  },
})
export default class ComposeUser extends Vue {
  private id: any = "";
  private typeText: any = "添加";
  private isEdit: boolean = false;
  private H: any = "";
  private data: any = {
    文献出处: [],
  };
  private addwenxian() {
    if (!this.data["文献出处"]) {
      this.data["文献出处"] = [];
    }
    this.data["文献出处"].push("");
  }
  private deleteOne(i: any) {
    this.data["文献出处"].splice(i, 1);
  }
  private getDetail() {
    const params = {
      intervene_way_id: this.id,
    };
    GanyuDetail(this, params).then((res: any) => {
      this.data = res;
    });
  }
  /**
   * @description 保存
   */
  private save() {
    if (!this.data["干预内容"]) {
      this.$message.error("请填写干预内容");
      return;
    }
    // if (this.data["干预内容"].length > 300) {
    //   this.$message.error("干预内容不能超过300字");
    //   return;
    // }
    // if (!this.data["证据来源分类"]) {
    //   this.$message.error("请选择证据来源");
    //   return;
    // }
    // if (!this.data["推荐级别分类"]) {
    //   this.$message.error("请选择推荐级别");
    //   return;
    // }
    // if (!this.data["所属慢病"]) {
    //   this.$message.error("请选择所属慢病");
    //   return;
    // }
    // if (!this.data["适用人群"]) {
    //   this.$message.error("请选择适用人群");
    //   return;
    // }
    if (!this.data["干预类型"]) {
      this.$message.error("请选择干预类型");
      return;
    }
    if (!this.data["状态"]) {
      this.$message.error("请选择状态");
      return;
    }
    const params = JSON.parse(JSON.stringify(this.data));
    editGanyu(this, params).then((data: any) => {
      this.$message.success(this.typeText + "成功");
      this.$router.back();
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.H = document.body.clientHeight - 50 - 14;
    if (this.$route.query.id) {
      this.typeText = "查看";
      this.id = this.$route.query.id;
      this.getDetail();
    } else {
      this.isEdit = true;
    }
  }
}
